module.exports = __webpack_public_path__ + "media/images/top/place/place3-a61290dccd522433ea7a35a213aab6e5.png";